import {Nullable, Optional} from '../../../../Common/TypeHelper'
import {MailMagazine, MailMagazineDTO, MailMagazineJSON} from './MailMagazineDTO'
import {PageUrlInfo, UrlListItem} from '../../Types'
import {ListUtility} from '../../../Utils/ListUtility'

export interface BucketInfoJSON {
  name: string
  mailMagazineList: MailMagazineJSON[]
  urlList: UrlListItem[]
  shopId: Nullable<string>
}

export interface BucketInfo {
  key: string
  name: string
  mailMagazineList: MailMagazine[]
  logoImg: Optional<string>
  urlInfoList: PageUrlInfo[]
  shopId: Nullable<string>
}

export class BucketInfoDTO implements BucketInfo {
  key: string
  name: string
  mailMagazineList: MailMagazine[]
  logoImg: Optional<string>
  urlInfoList: PageUrlInfo[]
  shopId: Nullable<string>

  constructor(
    key: string,
    name: string,
    mailMagazineList: MailMagazine[],
    logoImg: Optional<string>,
    urlInfoList: PageUrlInfo[],
    shopId: Nullable<string>,
  ) {
    this.key = key
    this.name = name
    this.mailMagazineList = mailMagazineList
    this.logoImg = logoImg
    this.urlInfoList = urlInfoList
    this.shopId = shopId
  }

  static fromJSON(
    jsonObject: BucketInfoJSON & { key: string },
  ): Nullable<BucketInfoDTO> {
    if (!jsonObject.name || !jsonObject.mailMagazineList) {
      return null
    }

    const filteredLogoImg = ListUtility.findOne<UrlListItem>(
      jsonObject.urlList || [],
      item => item.type === 'logoImg',
    )
    const logoImgUrl: Optional<string> = filteredLogoImg?.url

    const urlInfoListWithoutLogo = jsonObject.urlList
      .filter(url => url.type !== 'logoImg')
      .map(url => ({
        url: url.url,
        name: url.name !== '' ? url.name : '未設定',
      }))

    return new BucketInfoDTO(
      jsonObject.key,
      jsonObject.name,
      jsonObject.mailMagazineList.map(item => ({...MailMagazineDTO.fromJSON(item)})),
      logoImgUrl,
      urlInfoListWithoutLogo,
      jsonObject.shopId,
    )
  }
}
